import controller from './community.controller';
import template from './community.html';
import './community.scss';
/**
 * @ngdoc component
 * @name community
 * @description
 * The community component of the app.
 *
 * @memberof community
 */
export default {
  /**
   * The controller class for the component.
   * @type {CommunityController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/community/components/community/community.component.js